import { Component, inject } from '@angular/core';
import { ActionCardConfigInterface, BrightsideUiModule } from '@brightside/brightside-ui';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
    selector: 'brightside-web-helping-hands-initial-card',
    imports: [BrightsideUiModule],
    templateUrl: './helping-hands-initial-card.component.html',
    styleUrl: './helping-hands-initial-card.component.css'
})
export class HelpingHandsInitialCardComponent {
  actionCardConfig: ActionCardConfigInterface;

  private _translateSvc = inject(TranslateService);
  private _router = inject(Router);

  ngOnInit() {
    this.actionCardConfig = {
      label: this._translateSvc.instant('HELPING_HANDS_INITIAL_LABEL'),
      title: this._translateSvc.instant('HELPING_HANDS_INITIAL_TITLE'),
      labelIcon: '',
      cardStyle: 'small',
      image: './assets/hh-init-card.png',
      backgroundSize: 'cover',
      marginBottom: 'small'
    }
  }

  navigate() {
    this._router.navigate(['program', 'helping-hands']);
  }
}
